module.exports = __webpack_public_path__ + "static/media/universal_photo.cfa8b88f.jpeg";